// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as api from 'syft-acp-core/api'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('UPLOAD_IMAGE', api.uploadImage)
}
